/**
 * <pdp-usps> — PDP e-commerce USP list (icon + text rows from product features).
 *
 * The list itself is server-rendered (pdp-usps.liquid). This element only wires the
 * optional "mehr erfahren" affordance: for each .pdp-ecomm-item[data-usp-handle], if a
 * matching `<template data-usp-detail="<handle>">` exists in the document, it appends an
 * inline link button (data-sheet-push="<handle>"). The actual sheet open/push is handled
 * globally by bottom-up-sheet.js — this element only decides whether the link appears,
 * which keeps the feature ↔ detail coupling decoupled (by handle, no Liquid cross-block lookup).
 *
 * Upgrades automatically inside the quickview sheet (connectedCallback on the fetched PDP).
 */
class PdpUsps extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('.pdp-ecomm-item[data-usp-handle]').forEach((item) => {
      const handle = item.getAttribute('data-usp-handle');
      if (!handle) return;

      // Only offer the link when a detail view exists for this handle.
      const template = document.querySelector(`template[data-usp-detail="${CSS.escape(handle)}"]`);
      if (!template) return;

      // Idempotent: re-upgrades (quickview / morph) must not append twice.
      if (item.querySelector('.pdp-ecomm-more')) return;

      const text = item.querySelector('.pdp-ecomm-text p');
      if (!text) return;

      // Link text is admin-authored on the pdp-usp-detail block (data-link-title, default
      // "mehr erfahren") — freely editable/translatable per template.
      const label = template.dataset.linkTitle || 'mehr erfahren';
      const name = (text.textContent || '').trim();
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'pdp-ecomm-more pdp-link';
      button.setAttribute('data-sheet-push', handle);
      if (name) button.setAttribute('data-headline', name);
      button.textContent = label;

      // Inline, after the feature name: "Zufriedenheitsgarantie – mehr erfahren".
      text.append(' – ', button);
    });
  }
}

if (!customElements.get('pdp-usps')) {
  customElements.define('pdp-usps', PdpUsps);
}
